module.exports = __webpack_public_path__ + "img/telegram.01cacc28.svg";